export default __webpack_public_path__ + "static/logo-6-4f71c34c08cfcbb708e31837512e2ffd.png";